import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=49f2577e"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=49f2577e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports